/**
 * @param {string} str
 * @returns {string[]}
 */
export const stringToArray = function (str) {
  let delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
  return str.trim().split(delimiter).map(part => part.trim()).filter(part => part.length > 0);
};